<div class="star-rating" [class.star-rating--compact]="compact">
  @if (stars.length) {
    <div class="rating-stars">
      @for (star of stars; track $index) {
        <span
          class="star"
          [ngClass]="{ full: star === 1, half: star === 0.5, empty: star === 0 }"
          [style.--star-color]="starColor">
          ★
        </span>
      }
    </div>
  }
  @if (reviewCount !== null) {
    <span class="review-count">({{ reviewCount }} reviews)</span>
  }
</div>
